import type { InvoiceStatus } from "../../../shared/types/billing";
import { invoiceStatusLabel } from "../../../shared/format";
import { Badge, type BadgeProps } from "@/components/ui/badge";

const ICON: Record<InvoiceStatus, string> = {
  DRAFT: "○",
  POSTED: "•",
  PARTIALLY_PAID: "◐",
  PAID: "✔",
  VOIDED: "✕",
  REFUNDED: "↩",
};

const VARIANT: Record<InvoiceStatus, BadgeProps["variant"]> = {
  DRAFT: "muted",
  POSTED: "secondary",
  PARTIALLY_PAID: "warning",
  PAID: "success",
  VOIDED: "destructive",
  REFUNDED: "outline",
};

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  return (
    <Badge variant={VARIANT[status]} className="gap-1">
      <span aria-hidden="true">{ICON[status]}</span>
      {invoiceStatusLabel[status]}
    </Badge>
  );
}
